import React from 'react'

import { surveyReducer, initialState, Actions } from './reducer'

import { useAppNotification, TYPES } from '../AppNotificationProvider'

const SurveyContext = React.createContext(null)

const SurveyProvider = ({ children }) => {
  const showNotification = useAppNotification()

  const [state, dispatch] = React.useReducer(surveyReducer, initialState)
  const [eventQueue, setEventQueue] = React.useState([])

  // Survey events come here
  const handleEvent = React.useCallback(msg => {
    setEventQueue(old => [...old, msg])
  }, [])

  // Handles socket events from the queue
  const processEvent = React.useCallback(
    async msg => {
      try {
        const { id, sessionId, content } = msg
        const { body, user } = content

        showNotification({
          muteOn: null,
          type: TYPES.SURVEY,
          message: '',
          id,
          users: [user.id],
          name: body,
          msg
        })

        dispatch({
          type: Actions.ADD_SURVEY,
          id: sessionId,
          survey: msg
        })
      } catch (err) {
        console.error('Error getting survey', err)
      }
    },
    [showNotification]
  )

  // Processes and clears event queue
  React.useEffect(() => {
    if (!eventQueue.length) {
      return
    }

    eventQueue.forEach(processEvent)
    setEventQueue([])
  }, [eventQueue, processEvent])

  const getSurveys = React.useCallback(
    id => {
      return state.surveys[id] ?? []
    },
    [state.surveys]
  )

  const markSeen = React.useCallback(id => {
    dispatch({ type: Actions.CLEAR_UPDATE, id })
  }, [])

  return (
    <SurveyContext.Provider
      value={{ getSurveys, markSeen, updated: state.updated, handleEvent }}
    >
      {children}
    </SurveyContext.Provider>
  )
}

export default SurveyProvider

export const useSurvey = () => React.useContext(SurveyContext)
